/** @deprecated use constants/rubricas/situacao/RubricaSituacao.ts instead. */
export const SITUACOES_RUBRICA = [
  { value: 'ATIVA', label: 'Ativa' },
  { value: 'INATIVA', label: 'Inativa' },
  { value: 'EXCLUIDA', label: 'Excluída' },
  { value: 'NAO_UTILIZADA', label: 'Não utilizada' },
  { value: 'DESCONHECIDA', label: 'Desconhecida' },
] as const;
